// ============================================
// SDR Qualification Options
// ============================================

export const US_ENTRY_METHODS = [
  { value: 'tourist_visa', label: 'Visto de Turista (B1/B2)' },
  { value: 'student_visa', label: 'Visto de Estudante (F/J/M)' },
  { value: 'work_visa', label: 'Visto de Trabalho (H/L/O/P)' },
  { value: 'immigrant_visa', label: 'Visto de Imigrante (EB1/EB2/EB3/EB4/EB5)' },
  { value: 'ewi', label: 'Fronteira (EWI)' },
  { value: 'parole', label: 'Parole' },
  { value: 'refugee', label: 'Refugiado' },
] as const;

export const US_ENTRY_COUNT_OPTIONS = [
  { value: '1', label: '1 vez' },
  { value: '2', label: '2 vezes' },
  { value: '3', label: '3 vezes' },
  { value: '4', label: '4 vezes' },
  { value: '5+', label: '5 ou mais' },
] as const;

export const MONTHS_OPTIONS = [
  { value: 1, label: 'Janeiro' },
  { value: 2, label: 'Fevereiro' },
  { value: 3, label: 'Março' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Maio' },
  { value: 6, label: 'Junho' },
  { value: 7, label: 'Julho' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Setembro' },
  { value: 10, label: 'Outubro' },
  { value: 11, label: 'Novembro' },
  { value: 12, label: 'Dezembro' },
] as const;

export const ICE_CHECKIN_TIMELINE = [
  { value: 'this_week', label: 'Esta semana' },
  { value: 'next_week', label: 'Semana que vem' },
  { value: 'this_month', label: 'Este mês' },
  { value: 'next_month', label: 'Mês que vem' },
  { value: 'future', label: 'Mais de 1 mês' },
] as const;

export const MARITAL_STATUS_OPTIONS = [
  { value: 'single', label: 'Solteiro(a)' },
  { value: 'married', label: 'Casado(a)' },
  { value: 'divorced', label: 'Divorciado(a)' },
  { value: 'widowed', label: 'Viúvo(a)' },
  { value: 'domestic_partnership', label: 'União Estável' },
] as const;

export const IMMIGRATION_PROCESS_TYPES = [
  { value: 'green_card_family', label: 'Green Card (família)' },
  { value: 'green_card_employment', label: 'Green Card (trabalho)' },
  { value: 'asylum', label: 'Asilo' },
  { value: 'tps', label: 'TPS' },
  { value: 'daca', label: 'DACA' },
  { value: 'vawa', label: 'VAWA' },
  { value: 'u_visa', label: 'U-Visa' },
  { value: 't_visa', label: 'T-Visa' },
  { value: 'sijs', label: 'SIJS' },
  { value: 'o1', label: 'O-1' },
  { value: 'l1', label: 'L-1' },
  { value: 'eb1', label: 'EB-1' },
  { value: 'eb2', label: 'EB-2' },
  { value: 'eb3', label: 'EB-3' },
  { value: 'eb4', label: 'EB-4' },
  { value: 'eb5', label: 'EB-5' },
  { value: 'h1b', label: 'H-1B' },
  { value: 'naturalization', label: 'Naturalização' },
] as const;

export const PROCESS_STATUS_OPTIONS = [
  { value: 'approved', label: 'Aprovado' },
  { value: 'pending', label: 'Pendente' },
  { value: 'denied', label: 'Negado' },
  { value: 'expired', label: 'Expirado' },
  { value: 'abandoned', label: 'Abandonado' },
  { value: 'unknown', label: 'Não sei' },
] as const;

export const CURRENT_IMMIGRATION_STATUS = [
  { value: 'illegal', label: 'Ilegal / Sem Status' },
  { value: 'overstay', label: 'Overstay (visto vencido)' },
  { value: 'valid_visa', label: 'Visto Válido / Permanência Válida' },
  { value: 'tps', label: 'TPS' },
  { value: 'daca', label: 'DACA' },
  { value: 'permanent_resident', label: 'Residente Permanente (Green Card)' },
  { value: 'us_citizen', label: 'Cidadão Americano' },
] as const;

// Gender options
export const GENDER_OPTIONS = [
  { value: 'male', label: 'Masculino' },
  { value: 'female', label: 'Feminino' },
] as const;

// Language options
export const LANGUAGE_OPTIONS = [
  { value: 'portuguese', label: 'Português' },
  { value: 'spanish', label: 'Espanhol' },
  { value: 'english', label: 'Inglês' },
] as const;

// Country options
export const COUNTRY_OPTIONS = [
  { value: 'US', label: 'Estados Unidos' },
  { value: 'BR', label: 'Brasil' },
] as const;

export const QUALIFICATION_OBJECTIVES = [
  { value: 'green_card', label: 'Green Card' },
  { value: 'regularize_status', label: 'Regularizar Status' },
  { value: 'citizenship', label: 'Cidadania' },
  { value: 'work_visa', label: 'Visto de Trabalho' },
  { value: 'family_reunification', label: 'Reunificação Familiar' },
  { value: 'deportation_defense', label: 'Defesa de Deportação' },
  { value: 'renewal', label: 'Renovação (geral)' },
  { value: 'get_ead', label: 'Obter EAD' },
  { value: 'get_ssn', label: 'Obter SSN' },
  { value: 'get_ead_ssn', label: 'Obter EAD e SSN' },
  { value: 'renew_ead', label: 'Renovar EAD' },
  { value: 'renew_green_card', label: 'Renovar Green Card' },
  { value: 'unknown', label: 'Não definido' },
] as const;

export const URGENCY_OPTIONS = [
  { value: 'high', label: 'Alta (resolver em até 1 mês)' },
  { value: 'medium', label: 'Média (resolver em 1-3 meses)' },
  { value: 'low', label: 'Baixa (mais de 3 meses)' },
] as const;

export const BUDGET_RANGE_OPTIONS = [
  { value: 'under_5k', label: 'Menos de $5,000' },
  { value: '5k_10k', label: '$5,000 - $10,000' },
  { value: '10k_20k', label: '$10,000 - $20,000' },
  { value: '20k_plus', label: 'Mais de $20,000' },
  { value: 'unknown', label: 'Não informado' },
] as const;

export const EAD_STATUS_OPTIONS = [
  { value: 'valid', label: 'Válido' },
  { value: 'expired', label: 'Vencido' },
] as const;

// Status imigratório do cônjuge
export const SPOUSE_IMMIGRATION_STATUS = [
  { value: 'us_citizen', label: 'Cidadão Americano' },
  { value: 'green_card', label: 'Green Card' },
  { value: 'work_visa', label: 'Visto de Trabalho' },
  { value: 'illegal', label: 'Ilegal / Sem Status' },
  { value: 'unknown', label: 'Não sabe' },
] as const;

// Status imigratório dos filhos
export const CHILD_IMMIGRATION_STATUS = [
  { value: 'us_citizen', label: 'Cidadão Americano' },
  { value: 'green_card', label: 'Green Card' },
  { value: 'visa', label: 'Com Visto' },
  { value: 'illegal', label: 'Ilegal' },
  { value: 'unknown', label: 'Não sabe' },
] as const;

// Motivos para buscar outro escritório/assessoria
export const REASON_SEEKING_NEW_SERVICE = [
  { value: 'unsatisfied_service', label: 'Insatisfeito com atendimento' },
  { value: 'case_stalled', label: 'Processo parado' },
  { value: 'no_response', label: 'Escritório não responde' },
  { value: 'high_price', label: 'Preço alto' },
  { value: 'second_opinion', label: 'Quer segunda opinião' },
] as const;

// DEPRECATED - mantido para retrocompatibilidade
export const REASON_SEEKING_NEW_LAWYER = REASON_SEEKING_NEW_SERVICE;

// ============================================
// Interaction & Eligibility Options (Phase 2)
// ============================================

// Canais de interação
export const INTERACTION_CHANNELS = [
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'call', label: 'Ligação' },
  { value: 'email', label: 'E-mail' },
  { value: 'meeting', label: 'Reunião' },
  { value: 'sms', label: 'SMS' },
  { value: 'other', label: 'Outro' },
] as const;

// Direção da interação
export const INTERACTION_DIRECTIONS = [
  { value: 'outbound', label: 'Enviado (Outbound)' },
  { value: 'inbound', label: 'Recebido (Inbound)' },
] as const;

// Resultados da interação
export const INTERACTION_OUTCOMES = [
  { value: 'positive_response', label: 'Respondeu Positivo' },
  { value: 'objection', label: 'Respondeu com Objeção' },
  { value: 'no_response', label: 'Não Respondeu' },
  { value: 'requested_time', label: 'Pediu Tempo' },
  { value: 'closed', label: 'Fechou' },
  { value: 'gave_up', label: 'Desistiu' },
] as const;

// Tipos de objeção
export const OBJECTION_TYPES = [
  { value: 'price_discount', label: 'Preço - Quer Desconto' },
  { value: 'price_installment', label: 'Preço - Quer Parcelamento' },
  { value: 'timing', label: 'Timing - Não é o momento' },
  { value: 'spouse', label: 'Precisa falar com cônjuge' },
  { value: 'trust', label: 'Confiança - Precisa pensar' },
  { value: 'competitor', label: 'Concorrência - Comparando' },
  { value: 'documentation', label: 'Documentação - Faltam docs' },
  { value: 'other', label: 'Outro' },
] as const;

// Motivos de perda detalhados
export const DETAILED_LOST_REASONS = [
  { value: 'not_qualified_researching', label: 'Não qualificado - Apenas pesquisando' },
  { value: 'not_qualified_no_urgency', label: 'Não qualificado - Sem urgência' },
  { value: 'no_contact', label: 'Sem contato - Não conseguimos falar' },
  { value: 'noshow_2x', label: 'No-show 2x - Não compareceu' },
  { value: 'not_eligible', label: 'Não elegível - Sem opções viáveis' },
  { value: 'has_lawyer', label: 'Já tem advogado' },
  { value: 'price', label: 'Preço - Achou caro' },
  { value: 'timing', label: 'Timing - Não é o momento' },
  { value: 'competitor', label: 'Concorrência - Fechou com outro' },
  { value: 'spouse', label: 'Cônjuge - Não aprovou' },
  { value: 'trust', label: 'Confiança - Não se sentiu seguro' },
  { value: 'gave_up', label: 'Desistiu do processo' },
  { value: 'no_response', label: 'Sem resposta - Sumiu' },
  { value: 'other', label: 'Outro' },
] as const;

// Tipos de processo para elegibilidade
export const ELIGIBILITY_PROCESS_TYPES = [
  { value: 'eb1a', label: 'EB-1A (Habilidade Extraordinária)' },
  { value: 'eb2_niw', label: 'EB-2 NIW (National Interest Waiver)' },
  { value: 'eb3', label: 'EB-3 (Trabalhador Qualificado)' },
  { value: 'perm', label: 'PERM (Labor Certification)' },
  { value: 'vawa', label: 'VAWA (Violence Against Women Act)' },
  { value: 'u_visa', label: 'U-Visa (Vítima de Crime)' },
  { value: 't_visa', label: 'T-Visa (Tráfico Humano)' },
  { value: 'sijs', label: 'SIJS (Special Immigrant Juvenile)' },
  { value: 'asylum', label: 'Asilo' },
  { value: 'tps', label: 'TPS (Status de Proteção Temporária)' },
  { value: 'naturalization', label: 'Naturalização/Cidadania' },
  { value: 'renewal', label: 'Renovação' },
  { value: 'removal_defense', label: 'Defesa de Remoção' },
  { value: 'other', label: 'Outro' },
] as const;
